import { render } from "./DeleteCategoryIcon.vue?vue&type=template&id=57c4f5b2&scoped=true"
import script from "./DeleteCategoryIcon.vue?vue&type=script&lang=js"
export * from "./DeleteCategoryIcon.vue?vue&type=script&lang=js"

import "./DeleteCategoryIcon.vue?vue&type=style&index=0&id=57c4f5b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c4f5b2"]])

export default __exports__